import axios from "axios";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useHistory } from "react-router-dom";
import { HTTP_STATUSES } from "../../../../utils/consts";
import userAuthenticationConfig from "../../../../utils/userAuthenticationConfig";
import GoToBackButton from "../../../elements/goToBack/GoToBack";
import Notification from "../../../elements/notification/Notification";
import { StyledContentWrapper } from "../../../styles/styledMain";
import { StyledDocumentDetailsWrapper } from "../../styledDocument";
import DocumentDetailsContent from "./DocumentDetailsContent";

const DocumentDetailsContainer = ({ match }) => {
  const history = useHistory();
  let [document, setDocument] = useState(null);

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  //TODO Add pusher
  // const updateTransaction = (message) => {
  //   document = JSON.parse(message.data);
  //   setDocument(document);
  // };

  const fetchDocument = () => {
    axios.get("/api/aml-bots/" + match.params.id, userAuthenticationConfig()).then(response => {
      if (response.status === HTTP_STATUSES.HTTP_OK) {
        setDocument(response.data);
      }
    }).catch(error => {
      setNotification({ ...notification, visible: true, type: "error", message: error.response.data.message });
    });
  };

  useEffect(() => {
    fetchDocument();
  }, []);

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <StyledContentWrapper>
        <Helmet>
          <title>Детали проверки документов • eXsoft.io</title>
        </Helmet>
        <StyledDocumentDetailsWrapper>
          <div className="payout-details-head">
            <GoToBackButton
              handler={() => {history.goBack();}}
            />
          </div>
          <DocumentDetailsContent document={document} />
        </StyledDocumentDetailsWrapper>
      </StyledContentWrapper>
    </>
  );
};

export default DocumentDetailsContainer;